var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayQueueIcon = function SvgPlayQueueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.667 8c0 .733.6 1.333 1.333 1.333h21.333c.734 0 1.334-.6 1.334-1.333s-.6-1.333-1.334-1.333H4c-.733 0-1.333.6-1.333 1.333M2.667 16c0 .733.6 1.333 1.333 1.333h21.333c.734 0 1.334-.6 1.334-1.333s-.6-1.333-1.334-1.333H4c-.733 0-1.333.6-1.333 1.333M20 24c0-.733-.6-1.333-1.333-1.333H4c-.733 0-1.333.6-1.333 1.333s.6 1.333 1.333 1.333h14.667c.733 0 1.333-.6 1.333-1.333M30.44 24.88l-7-4.8a.47.47 0 0 0-.507-.013.54.54 0 0 0-.266.466v9.6c0 .2.093.373.266.467.16.093.36.08.507-.014l7-4.8a.53.53 0 0 0 .227-.453.54.54 0 0 0-.227-.453"
  }))));
};
export default SvgPlayQueueIcon;